import { Card } from 'antd';
import { StyledTable } from 'app/components/StyledTable/StyledTable';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IAreaByCultureListItem } from '../../slice/types';

interface IProps {
  areaByCultures: IAreaByCultureListItem[];
}

const TaskCulturesCard: FC<IProps> = ({ areaByCultures }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('Task.Details.CulturesTable.Culture', 'Culture'),
      dataIndex: 'cultureName',
      key: 'cultureName',
      sorter: {
        compare: (a: IAreaByCultureListItem, b: IAreaByCultureListItem) => {
          return a.cultureName.localeCompare(b.cultureName);
        },
      },
    },
    {
      title: t('Task.Details.CulturesTable.Area', 'Area'),
      dataIndex: 'readableArea',
      key: 'readableArea',
      width: '100px',
      sorter: {
        compare: (a: IAreaByCultureListItem, b: IAreaByCultureListItem) => {
          return a.area - b.area;
        },
      },
    },
  ];

  if (!areaByCultures.length) {
    return null;
  }

  return (
    <Card bordered={false} style={{ marginTop: 12 }}>
      <StyledTable
        rowKey="cultureId"
        dataSource={areaByCultures}
        columns={columns}
        pagination={false}
        bordered={true}
      />
    </Card>
  );
};

export default TaskCulturesCard;
